import React, { Component } from 'react';

class IndicatorTotalProducts extends Component {
  constructor(props) {
    super(props);
    this.recordsPerPage = this.props.recordsPerPage;
    this.currentPage = this.props.currentPage;
    this.labelTitle = this.props.labelTitle;
  }

  render() {
    const totalItemsShown = (recordsPerPage, currentPage) => {
      const totalResults = Number(this.props.totalRecords);
      const itemsCount = Number(this.props.itemsCount);
      const totalItems = itemsCount === totalResults ? totalResults : itemsCount;

      const itemsShown = (currentPage * recordsPerPage);
      const result = itemsShown >= totalItems ? totalItems : itemsShown;
      const itemsInPage = recordsPerPage >= totalItems ? totalItems : result;

      return itemsInPage;
    };

    return (
      <p style={{ textAlign: 'center' }}>
        {`${totalItemsShown(Number(this.props.recordsPerPage), Number(this.props.currentPage))} de ${this.props.itemsCount} ${this.labelTitle}`}
      </p>
    );
  }
}

export default IndicatorTotalProducts;
